"use client";

import { CheckCircle2, TriangleAlert } from "lucide-react";
import { useTheme } from "next-themes";
import { Toaster as Sonner, ToasterProps } from "sonner";

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      style={
        {
          "--normal-bg": "var(--color-muted)",
          "--normal-text": "var(--color-foreground)",
          "--normal-border": "var(--color-border)",
        } as React.CSSProperties
      }
      toastOptions={{
        style: {
          maxWidth: "320px",
          width: "auto",
          marginBottom: "44px",
        },
        classNames: {
          title: "font-semibold text-sm text-foreground",
          description: "text-sm font-normal text-text-secondary",
          default: "!bg-primary-subtle/10 !border-primary-subtle/25",
          info: "!bg-primary-subtle/10 !border-primary-subtle/25",
          error:
            "!bg-destructive/10 !text-destructive !border-destructive/25 [&_[data-description]]:!text-destructive",
        },
      }}
      icons={{
        success: <CheckCircle2 className="h-5 w-5 pr-1 text-foreground" />,
        error: <TriangleAlert className="h-5 w-5 pr-1 text-destructive" />,
      }}
      {...props}
    />
  );
};

export { Toaster };
